import gql from "graphql-tag";

export const SEND_WELCOME_QUERY = gql`
  mutation SendWelcomeMutation($mail: String!) {
    sendUserWelcome(email: $mail)
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/SendWelcomeMail/queries.ts